import { useEffect, useState } from "react";
import { BookOpen, Mic, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Reveal } from "./shared";

const OPTIONS = [
  {
    tipo: "ebook",
    icon: BookOpen,
    title: "Versione digitale (ebook)",
    text: "Il romanzo da leggere su e-reader, tablet e telefono.",
    testid: "interest-ebook-button",
  },
  {
    tipo: "podcast",
    icon: Mic,
    title: "Podcast delle leggende",
    text: "Le leggende del Lago d'Orta raccontate ad alta voce, a episodi.",
    testid: "interest-podcast-button",
  },
];

export default function Formati() {
  const [counts, setCounts] = useState(null);
  const [voted, setVoted] = useState({});

  useEffect(() => {
    setVoted({
      ebook: localStorage.getItem("voto-ebook") === "1",
      podcast: localStorage.getItem("voto-podcast") === "1",
    });
  }, []);

  const vote = async (tipo) => {
    if (voted[tipo]) return;
    try {
      const res = await api.post("/interesse", { tipo });
      setCounts(res.data.counts);
      setVoted((v) => ({ ...v, [tipo]: true }));
      localStorage.setItem(`voto-${tipo}`, "1");
      toast.success("Grazie! La tua voce è arrivata al lago.");
    } catch {
      toast.error("Voto non registrato. Riprova tra poco.");
    }
  };

  return (
    <section id="formati" className="relative border-y border-gold/15 bg-lake-teal/15 py-16 lg:py-24" data-testid="formati-section">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-gold">Al lancio solo in edizione cartacea</p>
          <h2 className="mt-4 font-serif text-2xl text-parchment-ivory sm:text-3xl">
            Ebook o podcast? La prossima mossa la decidete voi
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-parchment-ivory/65">
            In futuro Il Segreto del Lago potrebbe arrivare anche in digitale o diventare un podcast
            di leggende. Prima di farlo, vogliamo capire se ne vale la pena: un clic basta a farci
            sentire la tua voce.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {OPTIONS.map((o, i) => {
            const Icon = o.icon;
            const isVoted = voted[o.tipo];
            return (
              <Reveal key={o.tipo} delay={i * 0.12}>
                <button
                  data-testid={o.testid}
                  onClick={() => vote(o.tipo)}
                  disabled={isVoted}
                  className={`group flex w-full items-start gap-4 rounded-xl border p-6 text-left transition-all duration-300 ${
                    isVoted
                      ? "border-gold bg-gold/10"
                      : "border-parchment-ivory/20 bg-lake-deep/50 hover:-translate-y-1 hover:border-gold-shimmer/60"
                  }`}
                >
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${
                      isVoted ? "bg-gold text-ink-dark" : "bg-gold/15 text-gold-shimmer"
                    }`}
                  >
                    {isVoted ? <Check className="h-5 w-5" /> : <Icon className="h-5 w-5" />}
                  </span>
                  <span className="flex-1">
                    <span className="block text-sm font-semibold text-parchment-ivory">{o.title}</span>
                    <span className="mt-1 block text-xs leading-relaxed text-parchment-ivory/55">{o.text}</span>
                    <span className="mt-3 block text-xs font-medium text-gold-shimmer">
                      {isVoted
                        ? counts && counts[o.tipo] > 0
                          ? `Voto registrato · ${counts[o.tipo]} ${counts[o.tipo] === 1 ? "lettore interessato" : "lettori interessati"}`
                          : "Voto registrato · grazie!"
                        : "Mi interessa"}
                    </span>
                  </span>
                </button>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-6 text-center text-[11px] text-parchment-ivory/40">
            Un voto per formato per dispositivo. Nessuna email richiesta: ci serve solo capire
            quanti siete.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
